export default function validateHttpsUrl(url) {
  // Regular expression to match a valid HTTPS URL
  const httpsRegex = /^https:\/\/([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/

  // Test the URL against the regular expression
  return httpsRegex.test(url)
}
